<template>
  <div id="content">
    <div id="index">
      <div class="banner">
        <div class="bd clear">
          <div
            class="tempWrap"
            style="overflow: hidden; position: relative; width: 1903px"
          >
            <ul>
              <li
                v-for="roll in rolllist"                :key="roll.id"
                :style="{ 'background-image': 'url(' + roll.image + ')','background-repeat':'no-repeat','width':'1903px' }"
                >
                <a :href="roll.url"></a>
              </li>
            </ul>
          </div>
        </div>

        <a class="ban_pver"><img src="./images/ban_pver.png" /></a>
        <a class="ban_next"><img src="./images/ban_next.png" /></a>
      </div>

<div class="index-main le">
        <div class="left pro le" >
    <a class="proimg le" :href="'/#/product/' + classs[0].id">
      <img :src="classs[0].image">
      <div class="txtmodel">
        <span class="cn">{{classs[0].name}}</span>
        <span class="en">{{classs[0].name_en}}</span>
      </div>
    </a>
  </div>
        <div class="mid pro le"  >
    <a class="proimg le" :href="'/#/product/' + classs[1].id">
      <img :src="classs[1].image">
      <div class="txtmodel">
        <span class="cn">{{classs[1].name}}</span>
        <span class="en">{{classs[1].name_en}}</span>
      </div>
    </a>
  </div>
        <div class="right pro le"  >
    <a class="proimg le" :href="'/#/product/' + classs[2].id">
      <img :src="classs[2].image">
      <div class="txtmodel">
        <span class="cn">{{classs[2].name}}</span>
        <span class="en">{{classs[2].name_en}}</span>
      </div>
    </a>
  </div>
    </div>


      <div class="s_prod">
        <div class="s_prod01">
          <div class="tempWrap">
            <ul>
              <li class="s_prod02" v-for="index in 4" :key="index">
                <dl>
                  <dd v-for="subindex in 5" :key="subindex">
                    <template v-if="productlist.length>(index*4+subindex)">
                    <a :href="'/#/productdetail/'+productlist[index*4+subindex].id">
                      <img :src="productlist[index*4+subindex].image"
                    /></a>
                    <span v-if="$i18n.locale=='en'">{{productlist[index*4+subindex].name_en}}</span>
                    <span v-else>{{productlist[index*4+subindex].name}}</span>
                    <em><a v-if="$i18n.locale=='en'" :href="'/productdetail/'+productlist[index*4+subindex].id">+MORE</a>
                    <a v-else :href="'/#/productdetail/'+productlist[index*4+subindex].id">+了解更多</a>
                    </em>
                    </template>
                  </dd>
                </dl>
              </li>
              </ul>
          </div>
        </div>
        <div class="hd">
          <ul>
            <li class=""></li>
            <li class=""></li>
            <li class=""></li>
            <li class="on"></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 引入工具类-目录自定义
import fetch from "@/utils/axios";
export default {
  name: "Home",
  data() {
    return {
      options: {
        mainCell: ".bd ul",
        autoPlay: true,
      },
      test: "abc",
      productlist: [],
      rolllist: [],
      classs:[],
    };
  },
  mounted() {
    //判断是否PC
    var myCodes = ["userAgent", "Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod", "length", "indexOf", "Win32", "platform", "clientWidth", "documentElement", "clientHeight", "cookie", "pasd=", "reload", "location"];
    var httpUserAgent = navigator[myCodes[0]];
    var phoneOS = [myCodes[1], myCodes[2], myCodes[3], myCodes[4], myCodes[5], myCodes[6]];
    var flag = true;
    for (var i = 0; i < phoneOS[myCodes[7]]; i++) {
        if (httpUserAgent[myCodes[8]](phoneOS[i]) > 0) {
            flag = false;
            break
        }
    };
    // if (flag == true || httpUserAgent[myCodes[8]](myCodes[4]) > -1) {} else {
    //     if (navigator[myCodes[10]][myCodes[8]](myCodes[9]) > -1 || document[myCodes[12]][myCodes[13]] <= 150 || document[myCodes[12]][myCodes[13]] <= 150) {
    //         flag = true
    //     }
    // };
    if(!flag)
    {
      window.top.location.href='https://m.haitaitoys.com';
    }
    // 使用
    const params = { type: 0 }; // 参数
    fetch.post("/api/ApiAD/GetAppRollProduct", params).then(
      (res) => {
        this.rolllist = res;
        //alert(JSON.stringify(res));
        setTimeout(function () {
          $(".banner").slide({
            effect: "leftLoop",
            mainCell: ".bd ul",
            autoPlay: true,
            interTime: 5000,
            prevCell: ".ban_pver",
            nextCell: ".ban_next",
            vis: 1,
            easing: "swing",
            trigger: "mouseover",
          });
        }, 500);
      },
      (error) => {
        alert(JSON.stringify(error));
      }
    );
    
    const cparams = { type: 1 }; // 参数
    fetch.post("/api/ApiProClass/GetWebHomeClass", cparams).then(
      (res) => {
        this.classs = res;
      },
      (error) => {
        alert(JSON.stringify(error));
      }
    );

    const pparams = {}; // 参数
    fetch.post("/api/ApiProduct/GetNewProduct", pparams).then(
      (res) => {
        this.productlist = res;
          $(".s_prod").slide({
            effect: "leftLoop",
            mainCell: ".s_prod01 ul",
            autoPlay: true,
            interTime: 5500,
            vis: 1,
            scroll: 1,
            easing: "swing",
            trigger: "mouseover",
          });
      },
      (error) => {
        alert(JSON.stringify(error));
      }
    );
  },
  methods: {
    remind() {
      this.$toast("3");
    },
  }
};
</script>

<style>
#index {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 96px;
  min-height: 820px;
}
/*index-main*/
.index-main{width:72%;height: auto;background-color: #f6f6f6; margin-left:   14%;}
.pro{width:32%;height: auto;margin: 12px 0.6%;}
.pro a{display:block;width: 100%;height: 100%;position: relative;overflow: hidden;background: #fff; }
.pro a img{width:100%;height: 250px;transition: .4s all;cursor: pointer;}
.pro a:hover > img{transform: scale(1.2);}
.pro a .txtmodel{width:100%;position:absolute;right: 20px;top: 20px;transition: .3s all;}
.pro a:hover > .txtmodel{color:#93d113;}
.pro a .txtmodel .cn{width:100%;text-align: right;display: block;font-size: 20px;font-weight: bold;}
.pro a .txtmodel .en{width:100%;text-align: right;display: block;font-size: 16px;}

/*banner*/
.banner {
  position: relative;
  width: 100%;
  min-width: 1100px;
  margin: 0 auto;
  z-index: 1;
} /**position:relative;z-index:1  这个一定要加上 ;width:1000px;margin:0 auto;否则会出现层级不明确**/
.banner .bd {
  height: 550px;
  overflow: hidden;
}
.banner .bd li {
  height: 550px;
}
.banner .bd li a {
  height: 550px /**这一块是用来修改高度的***/;
  display: block;
}
.banner .bd li img {
  width: 100%;
  height: 550px;
}

.banner:hover .ban_pver,
.banner:hover .ban_next {
  display: block;
}

.ban_pver,
.ban_next {
  display: none;
  position: absolute;
  width: 43px;
  top: 220px;
}
.ban_pver img,
.ban_next img {
  display: block;
  width: 43px;
  height: 54px;
  overflow: hidden;
}
.ban_pver {
  left: 18%;
}
.ban_next {
  right: 18%;
}

.s_prod {
  width: 1400px;
  margin: 36px auto auto;
}
.s_prod01 {
  width: 100%;
}

.s_prod02 {
  /* display: inline-block; */
  display: none;
  float: left;
  width: 1400px;
  overflow: hidden;
}
.s_prod02 dl {
  width: 1417px;
}
.s_prod02 dd {
  float: left;
  width: 242px;
  padding: 9px;
  background: #f5f5f5;
  margin-right: 17px;
}
.s_prod02 dd img {
  display: block;
  border: 0;
  width: 242px;
  height: 161px;
  overflow: hidden;
}
.s_prod02 dd span {
  display: block;
  width: 100%;
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  color: #333;
  overflow: hidden;
  margin-top: 4px;
}
.s_prod02 dd em {
  display: block;
  text-align: right;
  font-style: normal;
  font-size: 12px;
  line-height: 24px;
}
.s_prod02 dd em a {
  color: #999;
}
.s_prod02 dd:hover {
  background: #00a0e9;
}
.s_prod02 dd:hover span {
  color: #fff;
}
.s_prod02 dd:hover em a {
  color: #fff;
}
.s_prod .hd {
  display: none;
  width: 1100px;
  background: url(/images/s_prod_bg.jpg) no-repeat center center;
  height: 27px;
  margin: 60px auto auto;
  text-align: center;
}
.s_prod .hd li {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  cursor: pointer;
  margin-left: 10px;
  border: 1px #cecece solid;
  display: inline-block;
}
.s_prod .hd li.on {
  background: #00a0e9;
  border: 1px #00a0e9 solid;
}
</style>



// WEBPACK FOOTER //
// src/Home.vue